module.exports = "/_next/static/images/275c3d624843187d621b806eb810f938-mother-and-daugther@0.75x.jpg.webp";